import React from 'react';

function OrderedList({fill = 'currentColor', secondaryfill, strokewidth = 1, width = '1em', height = '1em', ...props}) {
	secondaryfill = secondaryfill || fill;

	return (
		<svg height={height} width={width} {...props} viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
	<g fill={fill}>
		<path d="M6.548,16.5H2.5c-.208,0-.407-.086-.549-.239s-.214-.357-.199-.564c.122-1.719,1.489-2.278,2.487-2.686,.597-.243,1.592-.736,1.558-1.305-.038-.639-.922-.702-1.191-.706-.557-.025-1.201,.214-1.384,.863-.111,.398-.52,.634-.925,.52-.398-.112-.631-.526-.519-.925,.33-1.177,1.45-1.958,2.796-1.958,.019,0,.036,0,.054,0,1.521,.022,2.593,.873,2.667,2.116,.068,1.146-.77,2.083-2.489,2.784-.553,.226-.923,.402-1.164,.6h2.906c.414,0,.75,.336,.75,.75s-.336,.75-.75,.75Z" fill={secondaryfill}/>
		<path d="M16.25,6h-6.75c-.414,0-.75-.336-.75-.75s.336-.75,.75-.75h6.75c.414,0,.75,.336,.75,.75s-.336,.75-.75,.75Z" fill={fill}/>
		<path d="M16.25,13.5h-6.75c-.414,0-.75-.336-.75-.75s.336-.75,.75-.75h6.75c.414,0,.75,.336,.75,.75s-.336,.75-.75,.75Z" fill={fill}/>
		<path d="M4.75,8.25c-.414,0-.75-.336-.75-.75V3.708c-.307,.171-.664,.313-1.076,.393-.398,.074-.8-.189-.877-.596-.078-.407,.188-.799,.596-.877,.963-.184,1.439-.97,1.459-1.003,.173-.291,.524-.434,.845-.344,.326,.089,.554,.382,.554,.72V7.5c0,.414-.336,.75-.75,.75Z" fill={secondaryfill}/>
	</g>
</svg>
	);
};

export default OrderedList;